import styled from '@emotion/styled';
import { Typography as _Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment } from 'react';

import { DynamicSchemaDefinitionToggle } from '../../../../../graphql/generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionToggle, 'label' | 'checkedControlLabel' | 'uncheckedControlLabel'>;
  value: boolean;
  latestValue: boolean;
  beforeValue: boolean;
  className?: string;
}

const AsToggle = ({ field, latestValue, beforeValue, className }: Props & ClassAttributes<HTMLElement>) => {
  const latestLabel = latestValue ? field.checkedControlLabel : field.uncheckedControlLabel;
  const beforeLabel = beforeValue ? field.checkedControlLabel : field.uncheckedControlLabel;

  return (
    <Base field={field} className={className}>
      {latestLabel === beforeLabel ? (
        <Value variant="body1">{latestLabel}</Value>
      ) : (
        <Fragment>
          <Before variant="body1">{beforeLabel ? beforeLabel : '　'}</Before>
          <After variant="body1">{latestLabel ? latestLabel : '　'}</After>
        </Fragment>
      )}
    </Base>
  );
};

const Value = styled(_Typography)({});

const Before = styled(_Typography)({
  padding: '4px',
  marginBottom: '8px',
  background: '#fdd7d5',
});

const After = styled(_Typography)({
  padding: '4px',
  background: '#c8ffd8',
});

export default AsToggle;
